import { SeatFeature, SeatFeatureAliasLegend } from '../charter.types';

export const SEAT_FEATURE_CODE_ALIASES: Record<keyof SeatFeature, string> = {
  isExitRow: 'EX',
  hasExtraLegroom: 'XL',
};

const SEAT_FEATURE_ALIAS_DESCRIPTIONS: Record<keyof SeatFeature, string> = {
  isExitRow: 'Exit Row',
  hasExtraLegroom: 'Extra Legroom',
};

export const seatFeatureAliasLegend: Array<SeatFeatureAliasLegend> = (
  Object.keys(SEAT_FEATURE_CODE_ALIASES) as Array<keyof SeatFeature>
).map((key) => ({
  alias: SEAT_FEATURE_CODE_ALIASES[key],
  description: SEAT_FEATURE_ALIAS_DESCRIPTIONS[key],
}));
